import {GetAPICommand} from '@drl/core/core.module';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {environment} from '@drl/env/environment';

export class GetPatientOtp<T> extends GetAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>, id: number,isMinor: boolean=false) {
    super(apiService, adapter, `${environment.patientApiUrl}/${isMinor?'caregiver':'patients'}/${id}/otp`);
  }
}
